import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Globe2 } from 'lucide-react';
import { API } from '../governance_v2/constants';
import { MODULE_LABELS } from '../iad/constants';
import { Section, Table } from './parts';

const DistRow = ({ label, d, unit = '', testid }) => (
  <tr className="border-t border-slate-200 dark:border-slate-700" data-testid={testid}>
    <td className="p-2 font-medium">{label}</td><td className="p-2">{d.companies}</td>
    {d.insufficient ? <td className="p-2 text-xs text-slate-500" colSpan={3}>Muestra insuficiente (se necesitan al menos 3 empresas para proteger el anonimato)</td> : (
      <><td className="p-2">{d.min}{unit}</td><td className="p-2 font-bold">{d.median}{unit}</td><td className="p-2">{d.max}{unit}</td></>)}
  </tr>
);
const HEAD = ['', 'Empresas', 'Mínimo', 'Mediana', 'Máximo'];

export const HistoricalBenchmark = () => {
  const { data, isLoading } = useQuery({ queryKey: ['historical-benchmark'], queryFn: async () => (await axios.get(`${API}/historical/benchmark`)).data });
  return (
    <div className="space-y-6 p-8" data-testid="historical-benchmark">
      <div className="flex items-center gap-3">
        <Globe2 className="h-7 w-7 text-violet-500" />
        <div><h2 className="text-2xl font-bold text-slate-900 dark:text-white">Benchmark histórico entre empresas</h2>
          <p className="text-sm text-slate-500">Agregado y anónimo: solo distribuciones, sin nombres de empresas. Cada empresa aporta solo métricas con al menos 3 casos medidos, y una distribución se muestra cuando hay 3 o más empresas.</p></div>
      </div>
      {isLoading || !data ? <p className="text-sm text-slate-400">Calculando…</p> : (
        <>
          <p className="text-sm" data-testid="benchmark-companies">Empresas con historial de predicciones medidas: <b>{data.companies_with_history}</b></p>
          <Section title="Tasa de acierto de predicciones">
            <Table head={HEAD} empty="Sin datos." rows={data.prediction_hit_rate ? [<DistRow key="all" label="Todas las predicciones" d={data.prediction_hit_rate} unit="%" testid="benchmark-hit-rate" />] : []} />
          </Section>
          <Section title="SPI promedio por módulo">
            <Table head={HEAD} empty="Sin datos." rows={Object.entries(data.modules_spi).map(([m, d]) => <DistRow key={m} label={MODULE_LABELS[m] || m} d={d} testid={`benchmark-module-${m}`} />)} />
          </Section>
          <Section title="Acierto por metodología IAD">
            <Table head={HEAD} empty="Sin datos." rows={Object.entries(data.iad_hit_rate).map(([c, d]) => <DistRow key={c} label={c} d={d} unit="%" testid={`benchmark-iad-${c}`} />)} />
          </Section>
        </>
      )}
    </div>
  );
};
